/**
 * Admin page rendered at "/admin/comms" (nested route inside AdminHomepage, which is
 * mounted at "/admin/*" behind an admin-only ProtectedRoute). Simple tool for testing
 * outbound communications: two forms that send a test email and a test SMS through
 * api/admin (AdminAPI.sendTestEmail / AdminAPI.sendTestSMS), showing transient
 * error messages on failure.
 */
import React, { useState } from "react";
import { AdminAPI } from "../../../api/admin";

const CommsAdminPage: React.FC = () => {
    const [email, setEmail] = useState("adambollard@gmail.com");
    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+17178133117");
    const [message, setMessage] = useState("");
    const [emailError, setEmailError] = useState("");
    const [smsError, setSmsError] = useState("");

    const handleSendEmail = async () => {
        if (email && subject && body) {
            try {
                const response = await AdminAPI.sendTestEmail(email, subject, body);
                console.log("Email sent:", response);
                setEmailError(""); // Clear error on success
            } catch (error: any) {
                console.error("Error sending email:", error);
                setEmailError(error.message || "An error occurred while sending the email.");
                setTimeout(() => setEmailError(""), 5000); // Clear error after 5 seconds
            }
        } else {
            alert("Please fill in all email fields.");
        }
    };

    const handleSendSMS = async () => {
        if (phoneNumber && message) {
            try {
                const response = await AdminAPI.sendTestSMS(phoneNumber, message);
                console.log("SMS sent:", response);
                setSmsError(""); // Clear error on success
            } catch (error: any) {
                console.error("Error sending SMS:", error);
                setSmsError(error.message || "An error occurred while sending the SMS.");
                setTimeout(() => setSmsError(""), 5000); // Clear error after 5 seconds
            }
        } else {
            alert("Please fill in both SMS fields.");
        }
    };

    return (
        <div className="w-full max-w-4xl mx-auto p-4">
            <div className="bg-slate-50 p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-bold mb-4">send test email</h2>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mb-2 p-2 border border-gray-300 rounded-md"
                />
                <input
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    className="w-full mb-2 p-2 border border-gray-300 rounded-md"
                />
                <textarea
                    placeholder="Body"
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    className="w-full mb-4 p-2 border border-gray-300 rounded-md"
                />
                <button
                    onClick={handleSendEmail}
                    className="bg-white text-black px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                    send email
                </button>
                {emailError && <p className="text-sm text-red-500 mt-2">{emailError}</p>}
            </div>

            <div className="bg-slate-50 p-6 rounded-lg shadow-md mt-8">
                <h2 className="text-xl font-bold mb-4">send test sms</h2>
                <input
                    type="tel"
                    placeholder="Phone Number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="w-full mb-2 p-2 border border-gray-300 rounded-md"
                />
                <textarea
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full mb-4 p-2 border border-gray-300 rounded-md"
                />
                <button
                    onClick={handleSendSMS}
                    className="bg-white text-black px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
                >
                    send sms
                </button>
                {smsError && <p className="text-sm text-red-500 mt-2">{smsError}</p>}
            </div>
        </div>
    );
};

export default CommsAdminPage;
